$(document).on("ready turbolinks:load", () => {
    $("#export_select_child").change(function(){
        filter_by_group_for_export("child");
    });  
    
    $("#export_select_adult").change(function(){
        filter_by_group_for_export("adult");
    }); 

    $("#export_bulk_select").on('click',function(){
        select_checkbox();
    });

    $("#export_bulk_unselect").on('click',function(){
        unselect_checkbox();
    });

})

function select_checkbox(){

    var element = $('input[type="checkbox"]');

    $.each(element,function(){

        var booking_date_to = $(this).data('booking-date-to');
        var dt = new Date();
        var y = dt.getFullYear();
        var m = ("00" + (dt.getMonth()+1)).slice(-2);
        var d = ("00" + dt.getDate()).slice(-2);
        var today = y + m + d;

        var csv_published_date = $(this).data('csv-published');

        if (today <= booking_date_to){
            return false
        }
        
        if (csv_published_date == undefined || csv_published_date <= booking_date_to){
            $(this).prop('checked', true);
        }
        
    });

}

function unselect_checkbox(){
    $('input[type="checkbox"]:checked').prop('checked', false);
}


function filter_by_group_for_export(type){

    var element = document.getElementById("export_select_" + type);
    var group_no = element.value ;

    $.ajax({url:"/schedule_time_tables/"+ group_no + "/of_" + type + "_is_filter_by_group_for_export",
    type: "GET",
    dataType:"json"
    })
    .done(function(data){
        $(".card").remove();

        $.each(data,function(index,value){

            var card_html =  `
            <label>
                <div class="card control-select">
                    <input type="hidden" name="export_choose_form[schedule_nos][]">
                    <input type="checkbox" value="${value["schedule_no"]}" name="export_choose_form[schedule_nos][]" id="export_choose_form_schedule_nos_${value["schedule_no"]}" data-booking-date-to="${value["booking_date_to"]}" data-csv-published="${value["csv_published"]}">
                    <div>
                        <p>${value["enforce_date"]}</p>
                        <p>${value["group_for_disp"]}</p>
                        <p>予約人数： ${value["number_of_booking"]}人</p>
                        ${value["csv_published"] != null ? `<p>最終出力日時：${value["csv_published_for_disp"]}</p>` : ``}
                    </div>
                </div>
            </label>
            `
            
            $(".card--main").append(card_html);
        });

    });
}
